import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, ChapterHeader } from "./Reveal";

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], [60, -60]);
  const y2 = useTransform(scrollYProgress, [0, 1], [120, -40]);

  return (
    <section id="rostilj" ref={ref} className="relative py-28 sm:py-40 overflow-hidden bg-white" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <ChapterHeader
          number="01"
          title={<>Roštilj koji se <span className="text-leafdark">ne zaboravlja</span></>}
        />

        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div>
            <Reveal>
              <p className="font-display text-xl sm:text-2xl lg:text-[1.7rem] leading-snug font-medium text-leafdark">
                Više od 25 godina radimo isto: meso stiže sveže svako jutro, ložimo na{" "}
                <span className="text-ember">pravi ćumur</span>, a lepinju grejemo na samom žaru.
                Receptura se ne menja — jer kad nešto radi{" "}
                <span className="text-stroke-ember">do jaja</span>, ne diraš ga.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="text-leafdark/85 text-base md:text-lg leading-relaxed mt-8 max-w-xl">
                Nismo restoran. Nismo kafana. Mi smo ono mesto gde završi svaka dobra noć u
                Kragujevcu — i gde počinju sve priče koje se pričaju sutradan. Brzo, vrelo,
                pošteno i uvek isto: odlično.
              </p>
            </Reveal>
            <Reveal delay={0.25}>
              <div className="grid grid-cols-3 gap-6 mt-12 pt-8 border-t border-leaf/20">
                {[
                  { v: "100%", l: "sveže meso", cls: "text-ember" },
                  { v: "0", l: "prečica", cls: "text-leafdark" },
                  { v: "20", l: "priloga po izboru", cls: "text-ember" },
                ].map((s) => (
                  <div key={s.l}>
                    <p className={`font-display font-extrabold text-3xl sm:text-4xl ${s.cls}`}>{s.v}</p>
                    <p className="font-mono-x text-[10px] uppercase tracking-[0.2em] text-leafdark/70 mt-2">{s.l}</p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>

          <div className="relative h-[480px] sm:h-[560px]">
            <motion.div
              style={{ y: y1 }}
              className="absolute left-0 top-0 w-[62%] overflow-hidden rounded-[1.75rem] border-2 border-ember/15 shadow-[0_30px_60px_-25px_rgba(27,21,18,0.4)]"
            >
              <img src="/images/karadjordjeva.jpg" alt="Karađorđeva u lepinji sa prilozima" className="w-full aspect-[3/4] object-cover" data-testid="manifesto-image-1" />
            </motion.div>
            <motion.div
              style={{ y: y2 }}
              className="absolute right-0 bottom-0 w-[52%] overflow-hidden rounded-[1.75rem] border-2 border-leaf/35 shadow-[0_30px_60px_-25px_rgba(27,21,18,0.4)]"
            >
              <img src="/images/porcija.jpg" alt="Porcija sa pomfritom i salatom" className="w-full aspect-[4/5] object-cover" data-testid="manifesto-image-2" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
